import { useNavigate, useSearchParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import NewOvertimeRequestModal from 'modules/attendance/components/ClockIn/Modals/OvertimeRequest/New'
import { useAttendanceDateNavigator } from 'modules/attendance/lib/attendanceDateNavigatorContext'

const EmployeePeriodNewOvertimeRequestPage = () => {
  const { navigation } = useNavigation()
  const { employeeId } = useStrictParams<'employeeId' | 'year' | 'month'>()
  const navigate = useNavigate()
  const [searchParams, _] = useSearchParams()

  const { pathParams } = useAttendanceDateNavigator()

  const onClose = () => {
    navigate(navigation.clockIn.periodTypeYearMonthDay.fullPath(pathParams))
  }

  const hoursAmountParam = searchParams.get('hoursAmount')
  const hoursAmount = !hoursAmountParam || hoursAmountParam === 'undefined' ? 1 : +hoursAmountParam

  return (
    <NewOvertimeRequestModal
      employeeId={Number(employeeId)}
      hoursAmount={hoursAmount}
      onClose={onClose}
    />
  )
}

export default EmployeePeriodNewOvertimeRequestPage
